import { render, staticRenderFns } from "./ViewMarketplaceContract.vue?vue&type=template&id=512c1291&scoped=true&"
import script from "./ViewMarketplaceContract.vue?vue&type=script&lang=js&"
export * from "./ViewMarketplaceContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c1291",
  null
  
)

export default component.exports